import React, { lazy, useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,   FirstAds,MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
import bodyMeasureOutline from "../../../images/body-measure.webp";
const TITLE = "حاسبة تحديد شكل الجسم - اعرف شكل جسمك ";
const DESCRIPTION =
  "تساعدك حاسبة نوع الجسم على تحديد نوع جسمك بناءً على مقاسات الصدر والخصر والفخذين والورك. يمكن أن توفر لك رؤى حول شكل جسمك.";
const KEYWORDS =
  "حاسبة نوع الجسم, شكل الجسم, مقاس الصدر, مقاس الخصر, مقاس الورك, مقاس الفخذين";
const OG_URL = "https://do-calculate.com/calculator/ar/body-type-calculator/";
function BodyTypeCalculator() {
  const [bust, setBust] = useState("");
  const [waist, setWaist] = useState("");
  const [highHip, setHighHip] = useState("");
  const [hip, setHip] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  const [whr, setWHR] = useState(null);
  const handleBustChange = (event) => {
    setBust(event.target.value);
  };
  const handleWaistChange = (event) => {
    setWaist(event.target.value);
  };
  const handleHighHipChange = (event) => {
    setHighHip(event.target.value);
  };
  const handleHipChange = (event) => {
    setHip(event.target.value);
  };
  const calculateBodyType = () => {
    const bustNum = parseFloat(bust);
    const waistNum = parseFloat(waist);
    const highHipNum = parseFloat(highHip);
    const hipNum = parseFloat(hip);
    if (
      isNaN(bustNum) ||
      isNaN(waistNum) ||
      isNaN(highHipNum) ||
      isNaN(hipNum) ||
      bustNum <= 0 ||
      waistNum <= 0 ||
      highHipNum <= 0 ||
      hipNum <= 0
    ) {
      setError("أدخل قيم صحيحة");
      setResult(null);
      setWHR(null);
      return;
    }
    let bodyType = "غير معروف";
    const whrValue = (waistNum / hipNum).toFixed(2);
    if (bustNum === hipNum && waistNum < bustNum) {
      bodyType = "ساعة رملية";
    } else if (hipNum > bustNum && waistNum < hipNum) {
      bodyType = "كمثرى";
    } else if (bustNum > hipNum && waistNum < bustNum) {
      bodyType = "مثلث مقلوب";
    } else if (bustNum === waistNum && waistNum === hipNum) {
      bodyType = "مستطيل";
    } else if (waistNum >= bustNum && waistNum >= hipNum) {
      bodyType = "تفاحة";
    }
    setResult(bodyType);
    setWHR(whrValue);
    setError(null);
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-sm-12 col-md-9">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12 col-md-7">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  تساعدك حاسبة نوع الجسم على تحديد نوع جسمك بناءً على مقاسات
                  الصدر، الخصر، الورك، والفخذين. من خلال هذه الحاسبة، يمكنك
                  الحصول على فهم دقيق لشكل جسمك، مما يساعدك في اختيار الملابس
                  التي تناسبك بشكل مثالي. معرفة نوع جسمك لا تسهم فقط في تحسين
                  مظهرك، بل تزيد أيضاً من ثقتك بنفسك وراحتك في حياتك اليومية.
                  باستخدام الحاسبة، يمكنك تحديد المناطق التي ترغب في إبرازها
                  وتلك التي تود تقليلها، مما يسهم في اختيار الأزياء التي تعزز
                  مظهرك العام وتلائم أسلوبك الشخصي. سواء كنت تهدف إلى إبراز
                  جمالك الطبيعي أو تحقيق توازن بين تفاصيل جسمك المختلفة، فإن هذه
                  الحاسبة هي الأداة المثالية لتحقيق ذلك.
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-8 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  حاسبة نوع الجسم
                </div>
                <hr />
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="bust" className="form-label ms-2">
                      مقاس الصدر
                    </label>
                  </b>
                  <input
                    type="number"
                    id="bust"
                    value={bust}
                    onChange={handleBustChange}
                    className="form-control ml-2"
                    style={{ width: "120px" }}
                    placeholder="30"
                  />
                  <div className="input-group-append">
                    <span className="input-group-text">سم</span>
                  </div>
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="waist" className="form-label ms-2">
                      مقاس الخصر
                    </label>
                  </b>
                  <input
                    type="number"
                    id="waist"
                    value={waist}
                    onChange={handleWaistChange}
                    className="form-control ml-2"
                    style={{ width: "120px" }}
                    placeholder="30"
                  />
                  <div className="input-group-append">
                    <span className="input-group-text">سم</span>
                  </div>
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="highHip" className="form-label ms-2">
                      مقاس الفخذين
                    </label>
                  </b>
                  <input
                    type="number"
                    id="highHip"
                    value={highHip}
                    onChange={handleHighHipChange}
                    className="form-control ml-2"
                    style={{ width: "120px" }}
                    placeholder="30"
                  />
                  <div className="input-group-append">
                    <span className="input-group-text">سم</span>
                  </div>
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="hip" className="form-label ms-2">
                      مقاس الورك
                    </label>
                  </b>
                  <input
                    type="number"
                    id="hip"
                    value={hip}
                    onChange={handleHipChange}
                    className="form-control ml-2"
                    style={{ width: "120px" }}
                    placeholder="30"
                  />
                  <div className="input-group-append">
                    <span className="input-group-text">سم</span>
                  </div>
                </div>
                <br />
                <hr />
                <div>
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px" }}
                    onClick={calculateBodyType}
                  >
                    احسب                  </button>
                </div>
              </div>
              <div className="col-sm-12 col-md-4">
                <img
                  loading="lazy"
                  src={bodyMeasureOutline}
                  alt="توضيح القياسات"
                  style={{ width: "100%", paddingTop: "100px", height: "60%" }}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div>
                  {error && (
                    <div
                      style={{
                        backgroundColor: "#f8d7da",
                        borderColor: "#f5c6cb",
                        color: "#721c24",
                        padding: "15px",
                        marginBottom: "20px",
                        borderRadius: "4px",
                      }}
                    >
                      <b>
                        <u>خطأ:</u>
                      </b>{" "}
                      {error}
                    </div>
                  )}
                  { result && (
                    <div
                      style={{
                        backgroundColor: "#D1E7DD",
                        borderColor: "#c3e6cb",
                        color: "#155724",
                        padding: "15px",
                        marginBottom: "20px",
                        borderRadius: "4px",
                      }}
                    >
                      <h4>النتيجة:</h4>
                      <p
                        style={{
                          fontWeight: "bold",
                        }}
                      >
                        نوع جسمك هو: {result}
                      </p>
                      <p>نسبة الخصر إلى الورك (WHR): {whr}</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <hr /><div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <hr />
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                كيفية استخدام حاسبة نوع الجسم؟
              </div>
              <div className="info-section-body">
                <p>
                  لاستخدام حاسبة نوع الجسم، أدخل مقاسات الصدر، الخصر، الورك،
                  والفخذين. بعد ذلك، انقر على زر "احسب" للحصول على نوع جسمك.
                  تأكد من القياس بطريقة صحيحة للحصول على نتائج دقيقة.
                </p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">معلومات إضافية</div>
              <div className="info-section-body">
                <div className="info-sections-container">
                  <div className="info-section">
                    <div className="info-section-header">
                      كيف تقيس جسمك بشكل صحيح؟
                    </div>
                    <div className="info-section-body">
                      <p>
                        عند القياس، قف بشكل مستقيم مع ذراعيك مسترخيتين على
                        الجانبين. تأكد من أن شريط القياس ملامس للجسم دون ضغط
                        كبير على الجلد، لأن ذلك يمكن أن يؤدي إلى نتائج غير
                        دقيقة.
                      </p>
                      <ul>
                        <li>
                          <strong>مقاس الصدر</strong>: قياس محيط الصدر حول الجزء
                          الأكثر امتلاءً، مع ارتداء حمالة صدر مناسبة.
                        </li>
                        <li>
                          <strong>مقاس الخصر</strong>: قياس المحيط الأصغر حول
                          الخصر الطبيعي، فوق السرة بقليل.
                        </li>
                        <li>
                          <strong>مقاس الورك العلوي</strong>: قياس محيط الجزء
                          العلوي من الورك، حوالي 7 بوصات (18 سم) تحت الخصر
                          الطبيعي.
                        </li>
                        <li>
                          <strong>مقاس الورك</strong>: قياس المحيط حول الجزء
                          الأكثر امتلاءً من الورك والأرداف.
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      أشكال الجسم النسائية في صناعة الأزياء
                    </div>
                    <div className="info-section-body">
                      <p>
                        في صناعة الأزياء، يتم تصنيف أشكال جسم النساء عادة إلى
                        أربع فئات:
                      </p>
                      <ul>
                        <li>
                          <strong>التفاحة (المثلث المقلوب)</strong>: يتميز
                          بأكتاف وصدر أعرض من الوركين.
                        </li>
                        <li>
                          <strong>الموزة (مستقيم أو مستطيل)</strong>: يتميز
                          بقياس الخصر الذي يكون أقل من 9 بوصات من قياس الصدر أو
                          الورك.
                        </li>
                        <li>
                          <strong>الكمثرى (الملعقة، الجرس، المثلث)</strong>:
                          يتميز بقياسات الورك التي تكون أكبر من قياسات الصدر.
                        </li>
                        <li>
                          <strong>
                            الساعة الرملية (شكل X، المثلثات المتعاكسة)
                          </strong>
                          : يتميز بقياسات الصدر والورك المتساوية تقريبًا، مع خصر
                          ضيق.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default BodyTypeCalculator;
